import { OWN_ORIGIN } from "@/base/base.constants";
import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import type { ParsedUrlQuery } from "querystring";

type RedirectDestinationValue = ParsedUrlQuery[string] | null;

const getAllowedOrigins = () => {
  const allowedOrigins = [MONOLITH_ORIGIN, OWN_ORIGIN];

  if (typeof window !== "undefined" && window.location?.origin) {
    allowedOrigins.push(window.location.origin);
  }

  return new Set(
    allowedOrigins.flatMap((origin) => {
      try {
        return [new URL(origin).origin];
      } catch {
        return [];
      }
    }),
  );
};

export const getSafeRedirectDestination = (
  next: RedirectDestinationValue,
  fallback = MONOLITH_ORIGIN,
) => {
  const candidate = (Array.isArray(next) ? next[0] : next)?.trim();

  if (!candidate) return fallback;
  if (candidate.startsWith("/") && !candidate.startsWith("//"))
    return candidate;

  try {
    const url = new URL(candidate);

    return getAllowedOrigins().has(url.origin) ? url.toString() : fallback;
  } catch {
    return fallback;
  }
};
